import { genres } from '@/mocks/manga';

export default function Genres() {
  return (
    <section id="genres" className="scroll-mt-20 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        <div className="text-center">
          <span className="text-sm font-medium text-accent-700">EXPLORE GENRES</span>
          <h2 className="mt-2 font-heading text-2xl text-foreground-950 md:text-4xl">主题分类</h2>
          <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600 md:text-base">
            想找什么类型的漫画，直接进对应分区。每一类都经过编辑部人工筛选，避开滥竽充数之作。
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {genres.map((genre) => (
            <a
              key={genre.name}
              href="#toplist"
              className="group flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-200 hover:bg-background-100"
            >
              <div className="flex items-center justify-between">
                <span className="flex h-11 w-11 items-center justify-center rounded-md bg-secondary-100 text-xl text-secondary-800 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
                  <i className={genre.icon} aria-hidden="true"></i>
                </span>
                <i className="ri-arrow-right-line text-lg text-foreground-300 transition-colors group-hover:text-primary-600" aria-hidden="true"></i>
              </div>
              <h3 className="mt-4 text-base font-semibold text-foreground-950">{genre.name}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{genre.desc}</p>
              <span className="mt-3 text-xs text-secondary-700">{genre.count}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}